import * as types from './types';
import * as actionTypes from './constants';
import { IAction } from '@state/types';

const defaultState: types.IStorageState = { };

const designTypeReducer = (
  state: types.IStorageState = defaultState, 
  action: IAction | types.ISetFileAction
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_FILE: {
      return {...state, file: (action as types.ISetFileAction).file};
    }
    case actionTypes.SET_TOKEN: {
      return {...state, token: (action as types.ISetTokenAction).token};
    }
    case actionTypes.ADD_SUCCEEDED_FILE: {
      return {...state, response: (action as types.IServerSucceededAction).response};
    }
    default: {
      return state;
    }
  }
};


export default designTypeReducer;
